import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const FinancialAccounts = lazy(() => import('./FinancialAccounts'));

export const financialAccountRoutes: RouteObject[] = [
  { path: 'financial-accounts', element: <FinancialAccounts /> },
];
